import { Filters } from "@/types/filters";
import { filtersToUrl } from "./search-url-transform";

export interface ShareableSearchData {
	slug: string;
	url: string;
}

/**
 * Create a shareable search URL from current filters using the existing slug encoding system
 */
export function createShareableSearchUrl(filters: Partial<Filters>, city: string = "bengaluru"): ShareableSearchData {
	const slug = filtersToUrl(filters);
	const baseUrl = typeof window !== "undefined" ? window.location.origin : "";

	// Build the URL using the same structure as the search pages: /[city]/[slug]
	let url = baseUrl;
	if (city) {
		url += `/${city.toLowerCase()}`;
		if (slug) {
			url += `/${slug}`;
		}
	} else {
		// Fallback to current path if no city provided
		const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
		url += currentPath;
		if (slug) {
			url += slug.startsWith("/") ? slug : `/${slug}`;
		}
	}

	return {
		slug,
		url,
	};
}

/**
 * Copy text to clipboard with fallback
 */
export async function copyToClipboard(text: string): Promise<boolean> {
	try {
		if (navigator.clipboard && window.isSecureContext) {
			await navigator.clipboard.writeText(text);
			return true;
		} else {
			// Fallback for older browsers or non-secure contexts
			const textArea = document.createElement("textarea");
			textArea.value = text;
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			const result = document.execCommand("copy");
			document.body.removeChild(textArea);
			return result;
		}
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error("Failed to copy text:", err);
		return false;
	}
}
